import _ from "./index255.js";
import { resolveComponent as a, createBlock as B, openBlock as s, withCtx as m, createElementVNode as l, createElementBlock as r, createCommentVNode as n, createVNode as i, toDisplayString as c, Transition as C, createTextVNode as d, normalizeClass as y, Fragment as v, renderList as b } from "vue";
/* empty css         */
import h from "./index231.js";
const S = { class: "cs-filterBar" }, g = {
  key: 0,
  class: "cs-filterBar__results"
}, D = {
  key: 1,
  class: "cs-filterBar__divider",
  "data-test-id": "divider"
}, F = {
  type: "button",
  class: "cs-filterBar__button"
}, V = ["value", "selected"], $ = {
  key: 2,
  class: "cs-filterBar__divider -bookmark"
};
function w(e, t, N, O, M, A) {
  const k = a("ms-settings"), u = a("ms-sort"), f = a("cs-bookmark-icon"), p = a("cs-sticky-container");
  return s(), B(p, {
    "data-mod": e.$options.name,
    maxScrollDepth: e.maxScrollDepth,
    "onChange:stickiness": e.onStickyChange
  }, {
    default: m(() => [
      l("div", S, [
        e.amountOfResults ? (s(), r("div", g, c(e.amountOfResults), 1)) : n("", !0),
        i(C, {
          "enter-to-class": "opacity-1",
          "leave-to-class": "opacity-0"
        }, {
          default: m(() => [
            e.isScreenM || !e.isScreenM && e.isSticky ? (s(), r("button", {
              key: 0,
              type: "button",
              class: "cs-filterBar__button -filter",
              "data-test-id": "filter",
              onClick: t[0] || (t[0] = (...o) => e.onClickFilter && e.onClickFilter(...o))
            }, [
              i(k, { class: "cs-filterBar__icon" }),
              t[3] || (t[3] = d(" Filter ")),
              e.amountOfFilter ? (s(), r("span", {
                key: 0,
                class: y(["cs-filterBar__filterAmount", e.filterColor]),
                "data-test-id": "filterAmount"
              }, c(e.amountOfFilter), 3)) : n("", !0)
            ])) : n("", !0)
          ]),
          _: 1
        }),
        e.isScreenM ? (s(), r("div", D)) : n("", !0),
        l("div", F, [
          i(u, { class: "cs-filterBar__icon" }),
          t[4] || (t[4] = d("Sortierung ")),
          l("select", {
            class: "cs-filterBar__sort",
            onChange: t[1] || (t[1] = (...o) => e.onSortChange && e.onSortChange(...o))
          }, [
            (s(!0), r(v, null, b(e.options, (o) => (s(), r("option", {
              key: o.value,
              value: o.value,
              selected: o.value === e.modelValue
            }, c(o.label), 9, V))), 128))
          ], 32)
        ]),
        e.showBookmarks ? (s(), r("div", $)) : n("", !0),
        e.showBookmarks ? (s(), r("button", {
          key: 3,
          type: "button",
          class: "cs-filterBar__bookmarkIcon",
          "aria-label": "show bookmarks",
          "data-test-id": "bookmark",
          onClick: t[2] || (t[2] = (...o) => e.onClickBookmark && e.onClickBookmark(...o))
        }, [
          i(f, { hasDot: e.hasDot }, null, 8, ["hasDot"])
        ])) : n("", !0)
      ])
    ]),
    _: 1
  }, 8, ["data-mod", "maxScrollDepth", "onChange:stickiness"]);
}
const z = /* @__PURE__ */ h(_, [["render", w], ["__scopeId", "data-v-974450fc"]]);
export {
  z as default
};
